/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * (tsType: QuestionTypeWithRelations, schemaOptions: { includeRelations: true })
 */
export interface QuestionTypeWithRelations { 
    id: string;
    name: string;
    description?: string;
    category?: string;
    hasOptions: boolean;
    supportsJustification: boolean;
    supportsOtherOption: boolean;
    icon?: string;
    configSchema?: object;
    exampleSettings?: object;
    orderIndex: number;
    isActive: boolean;
    createdOn: string;
    modifiedOn: string;
}

